const loader = {
  v: "4.6.9",
  fr: 50,
  ip: 0,
  op: 409,
  w: 1080,
  h: 1080,
  nm: "Loader BodyMovin",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "Easer",
      ks: {
        o: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: -96,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.327], y: [0.86] },
                o: { x: [0.622], y: [0.085] },
                n: ["0p327_0p86_0p622_0p085"],
                t: -90,
                s: [2.202],
                e: [97.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: -78,
                s: [97.04],
                e: [100],
              },
              { t: -72 },
            ],
          },
          y: { a: 0, k: 0 },
        },
        a: { a: 0, k: [0, 0, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.811, 0.811, 0.833], y: [0.518, 0.518, 0.833] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0.333] },
              n: [
                "0p811_0p518_0p333_0",
                "0p811_0p518_0p333_0",
                "0p833_0p833_0p333_0p333",
              ],
              t: -96,
              s: [0, 0, 100],
              e: [2.202, 2.202, 100],
            },
            {
              i: { x: [0.341, 0.341, 0.833], y: [0.871, 0.871, 0.833] },
              o: { x: [0.61, 0.61, 0.167], y: [0.072, 0.072, 0.167] },
              n: [
                "0p341_0p871_0p61_0p072",
                "0p341_0p871_0p61_0p072",
                "0p833_0p833_0p167_0p167",
              ],
              t: -90,
              s: [2.202, 2.202, 100],
              e: [97.04, 97.04, 100],
            },
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 0.667] },
              o: { x: [0.213, 0.213, 0.167], y: [0.665, 0.665, 0.167] },
              n: [
                "0p667_1_0p213_0p665",
                "0p667_1_0p213_0p665",
                "0p667_0p667_0p167_0p167",
              ],
              t: -78,
              s: [97.04, 97.04, 100],
              e: [100, 100, 100],
            },
            { t: -72 },
          ],
        },
      },
      ao: 0,
      ip: 0,
      op: 409,
      st: -96,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 3,
      nm: "Mirror",
      ks: {
        o: { a: 0, k: 0 },
        r: { a: 0, k: 0 },
        p: { a: 0, k: [540, 540, 0] },
        a: { a: 0, k: [0, 0, 0] },
        s: { a: 0, k: [-100, 100, 100] },
      },
      ao: 0,
      ip: 0,
      op: 409,
      st: -96,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Aqua 16",
      parent: 2,
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 170,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 176,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 187,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 198,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 204,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 210,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 221,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 232,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 238,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 340,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 346,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 357,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 368,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 374,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 380,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 391,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 402,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 408,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 578,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 579,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 585,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 596,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 607,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 613,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 619,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 630,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 641,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 647,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 749,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 755,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 766,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 777,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 783,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 789,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 800,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 811,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 817,
                s: [202.5],
                e: [202.5],
              },
              { t: 987 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 170,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 176,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 187,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 198,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 204,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 238,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 244,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 255,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 266,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 272,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 306,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 312,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 323,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 334,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 340,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 374,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 380,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 391,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 402,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 408,
                s: [-739.439],
                e: [-739.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 578,
                s: [-739.439],
                e: [67.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 579,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 585,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 596,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 607,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 613,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 647,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 653,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 664,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 675,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 681,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 715,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 721,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 732,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 743,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 749,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 783,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 789,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 800,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 811,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 817,
                s: [-739.439],
                e: [-739.439],
              },
              { t: 987 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: {
                                a: 0,
                                k: [0.1372549, 0.4784314, 0.7294118, 1],
                              },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 170,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 306,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 312,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 323,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 334,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 340,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 578,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 579,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 715,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 721,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 732,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 743,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 749,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 987 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 170,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 238,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 244,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 255,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 266,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 272,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 578,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 579,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 647,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 653,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 664,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 675,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 681,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 987 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 170,
      op: 409,
      st: 170,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Aqua 13",
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 102,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 108,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 119,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 130,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 136,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 142,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 153,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 164,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 170,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 272,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 278,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 289,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 300,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 306,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 312,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 323,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 334,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 340,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 510,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 511,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 517,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 528,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 539,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 545,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 551,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 562,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 573,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 579,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 681,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 687,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 698,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 709,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 715,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 721,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 732,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 743,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 749,
                s: [742.5],
                e: [742.5],
              },
              { t: 919 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 102,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 108,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 119,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 130,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 136,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 170,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 176,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 187,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 198,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 204,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 238,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 244,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 255,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 266,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 272,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 306,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 312,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 323,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 334,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 340,
                s: [-199.439],
                e: [-199.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 510,
                s: [-199.439],
                e: [607.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 511,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 517,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 528,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 539,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 545,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 579,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 585,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 596,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 607,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 613,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 647,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 653,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 664,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 675,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 681,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 715,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 721,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 732,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 743,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 749,
                s: [-199.439],
                e: [-199.439],
              },
              { t: 919 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: { a: 0, k: [0, 0.2666667, 0.5058824, 1] },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 102,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 238,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 244,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 255,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 266,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 272,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 510,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 511,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 647,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 653,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 664,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 675,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 681,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 919 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 102,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 170,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 176,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 187,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 198,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 204,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 510,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 511,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 579,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 585,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 596,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 607,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 613,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 919 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 102,
      op: 409,
      st: 102,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Aqua 15",
      parent: 2,
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 34,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 40,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 51,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 62,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 68,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 74,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 85,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 96,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 102,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 204,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 210,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 221,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 232,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 238,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 244,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 255,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 266,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 272,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 441,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 442,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 448,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 459,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 470,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 476,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 482,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 493,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 504,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 510,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 612,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 618,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 629,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 640,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 646,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 652,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 663,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 674,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 680,
                s: [202.5],
                e: [202.5],
              },
              { t: 850 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 34,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 40,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 51,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 62,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 68,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 102,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 108,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 119,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 130,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 136,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 170,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 176,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 187,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 198,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 204,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 238,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 244,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 255,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 266,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 272,
                s: [-739.439],
                e: [-739.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 441,
                s: [-739.439],
                e: [67.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 442,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 448,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 459,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 470,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 476,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 510,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 516,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 527,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 538,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 544,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 578,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 584,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 595,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 606,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 612,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 646,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 652,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 663,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 674,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 680,
                s: [-739.439],
                e: [-739.439],
              },
              { t: 850 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: { a: 0, k: [0.1764706, 0.8, 0.8039216, 1] },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 34,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 170,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 176,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 187,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 198,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 204,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 441,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 442,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 578,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 584,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 595,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 606,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 612,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 850 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 34,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 102,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 108,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 119,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 130,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 136,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 441,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 442,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 510,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 516,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 527,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 538,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 544,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 850 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 34,
      op: 409,
      st: 34,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Aqua 12",
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -34,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -28,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -17,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -6,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 0,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 6,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 17,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 28,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 34,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 136,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 142,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 153,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 164,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 170,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 176,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 187,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 198,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 204,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 373,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 374,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 380,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 391,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 402,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 408,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 414,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 425,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 436,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 442,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 544,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 550,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 561,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 572,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 578,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 584,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 595,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 606,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 612,
                s: [742.5],
                e: [742.5],
              },
              { t: 782 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -34,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -28,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -17,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -6,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 0,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 34,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 40,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 51,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 62,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 68,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 102,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 108,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 119,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 130,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 136,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 170,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 176,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 187,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 198,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 204,
                s: [-199.439],
                e: [-199.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 373,
                s: [-199.439],
                e: [607.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 374,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 380,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 391,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 402,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 408,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 442,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 448,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 459,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 470,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 476,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 510,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 516,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 527,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 538,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 544,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 578,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 584,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 595,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 606,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 612,
                s: [-199.439],
                e: [-199.439],
              },
              { t: 782 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: {
                                a: 0,
                                k: [0.1372549, 0.4784314, 0.7294118, 1],
                              },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: -34,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 102,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 108,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 119,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 130,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 136,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 373,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 374,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 510,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 516,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 527,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 538,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 544,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 782 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: -34,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 34,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 40,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 51,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 62,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 68,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 373,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 374,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 442,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 448,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 459,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 470,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 476,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 782 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 0,
      op: 409,
      st: -34,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Aqua 14",
      parent: 2,
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -102,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -96,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -85,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -74,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -68,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: -62,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: -51,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -40,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: -34,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 68,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 74,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 85,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 96,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 102,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 108,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 119,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 130,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 136,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 305,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 306,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 312,
                s: [199.54],
                e: [106.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 323,
                s: [106.769],
                e: [2.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 334,
                s: [2.202],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 340,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 346,
                s: [-2.96],
                e: [-397.375],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 357,
                s: [-397.375],
                e: [-875.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 368,
                s: [-875.798],
                e: [-878],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 374,
                s: [-878],
                e: [-878],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 476,
                s: [-878],
                e: [-875.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 482,
                s: [-875.798],
                e: [-397.375],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 493,
                s: [-397.375],
                e: [-2.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 504,
                s: [-2.96],
                e: [0],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 510,
                s: [0],
                e: [2.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 516,
                s: [2.202],
                e: [106.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 527,
                s: [106.769],
                e: [199.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 538,
                s: [199.54],
                e: [202.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 544,
                s: [202.5],
                e: [202.5],
              },
              { t: 714 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -102,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -96,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -85,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -74,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: -68,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -34,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -28,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -17,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -6,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 0,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 34,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 40,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 51,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 62,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 68,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 102,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 108,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 119,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 130,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 136,
                s: [-739.439],
                e: [-739.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 305,
                s: [-739.439],
                e: [67.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 306,
                s: [67.46],
                e: [64.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 312,
                s: [64.5],
                e: [-28.253],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 323,
                s: [-28.253],
                e: [-132.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 334,
                s: [-132.798],
                e: [-135],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 340,
                s: [-135],
                e: [-135],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 374,
                s: [-135],
                e: [-137.96],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 380,
                s: [-137.96],
                e: [-230.731],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 391,
                s: [-230.731],
                e: [-335.298],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 402,
                s: [-335.298],
                e: [-337.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 408,
                s: [-337.5],
                e: [-337.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 442,
                s: [-337.5],
                e: [-340.46],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 448,
                s: [-340.46],
                e: [-433.214],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 459,
                s: [-433.214],
                e: [-537.758],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 470,
                s: [-537.758],
                e: [-539.96],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 476,
                s: [-539.96],
                e: [-540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 510,
                s: [-540],
                e: [-542.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 516,
                s: [-542.96],
                e: [-634.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 527,
                s: [-634.364],
                e: [-737.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 538,
                s: [-737.237],
                e: [-739.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 544,
                s: [-739.439],
                e: [-739.439],
              },
              { t: 714 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: { a: 0, k: [0, 0.2666667, 0.5058824, 1] },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: -102,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 34,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 40,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 51,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 62,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 68,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 305,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 306,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 442,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 448,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 459,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 470,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 476,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 714 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: -102,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: -34,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: -28,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: -17,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: -6,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 0,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 305,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 306,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 374,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 380,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 391,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 402,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 408,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 714 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 0,
      op: 409,
      st: -102,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Aqua 6",
      ks: {
        o: { a: 0, k: 100 },
        r: { a: 0, k: 0 },
        p: {
          s: !0,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -170,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -164,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -153,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -142,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -136,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: -130,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: -119,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -108,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: -102,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 0,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 6,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 17,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 28,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 34,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 40,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 51,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 62,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 68,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 237,
                s: [742.5],
                e: [742.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 238,
                s: [742.5],
                e: [739.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 244,
                s: [739.54],
                e: [646.769],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 255,
                s: [646.769],
                e: [542.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 266,
                s: [542.202],
                e: [540],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 272,
                s: [540],
                e: [537.04],
              },
              {
                i: { x: [0.832], y: [0.5] },
                o: { x: [0.625], y: [0.029] },
                n: ["0p832_0p5_0p625_0p029"],
                t: 278,
                s: [537.04],
                e: [142.625],
              },
              {
                i: { x: [0.334], y: [0.984] },
                o: { x: [0.193], y: [0.476] },
                n: ["0p334_0p984_0p193_0p476"],
                t: 289,
                s: [142.625],
                e: [-335.798],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 300,
                s: [-335.798],
                e: [-338],
              },
              {
                i: { x: [0.667], y: [0.667] },
                o: { x: [0.333], y: [0.333] },
                n: ["0p667_0p667_0p333_0p333"],
                t: 306,
                s: [-338],
                e: [-338],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 408,
                s: [-338],
                e: [-335.798],
              },
              {
                i: { x: [0.807], y: [0.524] },
                o: { x: [0.666], y: [0.016] },
                n: ["0p807_0p524_0p666_0p016"],
                t: 414,
                s: [-335.798],
                e: [142.625],
              },
              {
                i: { x: [0.375], y: [0.971] },
                o: { x: [0.168], y: [0.5] },
                n: ["0p375_0p971_0p168_0p5"],
                t: 425,
                s: [142.625],
                e: [537.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 436,
                s: [537.04],
                e: [540],
              },
              {
                i: { x: [0.743], y: [0.247] },
                o: { x: [0.333], y: [0] },
                n: ["0p743_0p247_0p333_0"],
                t: 442,
                s: [540],
                e: [542.202],
              },
              {
                i: { x: [0.807], y: [0.545] },
                o: { x: [0.666], y: [0.075] },
                n: ["0p807_0p545_0p666_0p075"],
                t: 448,
                s: [542.202],
                e: [646.769],
              },
              {
                i: { x: [0.375], y: [0.878] },
                o: { x: [0.168], y: [0.445] },
                n: ["0p375_0p878_0p168_0p445"],
                t: 459,
                s: [646.769],
                e: [739.54],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.261], y: [0.87] },
                n: ["0p667_1_0p261_0p87"],
                t: 470,
                s: [739.54],
                e: [742.5],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 476,
                s: [742.5],
                e: [742.5],
              },
              { t: 646 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -170,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -164,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -153,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -142,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: -136,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -102,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -96,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -85,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -74,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: -68,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: -34,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: -28,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: -17,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: -6,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 0,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 34,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 40,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 51,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 62,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 68,
                s: [-199.439],
                e: [-199.439],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                n: ["0p667_1_0p167_0p167"],
                t: 237,
                s: [-199.439],
                e: [607.46],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 238,
                s: [607.46],
                e: [604.5],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 244,
                s: [604.5],
                e: [511.747],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 255,
                s: [511.747],
                e: [407.202],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 266,
                s: [407.202],
                e: [405],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 272,
                s: [405],
                e: [405],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 306,
                s: [405],
                e: [402.04],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 312,
                s: [402.04],
                e: [309.269],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 323,
                s: [309.269],
                e: [204.702],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 334,
                s: [204.702],
                e: [202.5],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 340,
                s: [202.5],
                e: [202.5],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 374,
                s: [202.5],
                e: [199.54],
              },
              {
                i: { x: [0.832], y: [0.555] },
                o: { x: [0.625], y: [0.122] },
                n: ["0p832_0p555_0p625_0p122"],
                t: 380,
                s: [199.54],
                e: [106.786],
              },
              {
                i: { x: [0.334], y: [0.925] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p925_0p193_0p455"],
                t: 391,
                s: [106.786],
                e: [2.242],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 402,
                s: [2.242],
                e: [0.04],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.333], y: [0] },
                n: ["0p667_1_0p333_0"],
                t: 408,
                s: [0.04],
                e: [0],
              },
              {
                i: { x: [0.739], y: [0.13] },
                o: { x: [0.333], y: [0] },
                n: ["0p739_0p13_0p333_0"],
                t: 442,
                s: [0],
                e: [-2.96],
              },
              {
                i: { x: [0.832], y: [0.556] },
                o: { x: [0.625], y: [0.124] },
                n: ["0p832_0p556_0p625_0p124"],
                t: 448,
                s: [-2.96],
                e: [-94.364],
              },
              {
                i: { x: [0.334], y: [0.923] },
                o: { x: [0.193], y: [0.455] },
                n: ["0p334_0p923_0p193_0p455"],
                t: 459,
                s: [-94.364],
                e: [-197.237],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.257], y: [0.753] },
                n: ["0p667_1_0p257_0p753"],
                t: 470,
                s: [-197.237],
                e: [-199.439],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.333], y: [0] },
                n: ["0p833_0p833_0p333_0"],
                t: 476,
                s: [-199.439],
                e: [-199.439],
              },
              { t: 646 },
            ],
          },
        },
        a: { a: 0, k: [0, -375, 0] },
        s: { a: 0, k: [100, 100, 100] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "gr",
              it: [
                {
                  ty: "gr",
                  it: [
                    {
                      ty: "gr",
                      it: [
                        {
                          ty: "gr",
                          it: [
                            {
                              ty: "rc",
                              d: 1,
                              s: { a: 0, k: [1080, 675] },
                              p: { a: 0, k: [0, 0] },
                              r: { a: 0, k: 0 },
                              nm: "Rectangle Path 1",
                              mn: "ADBE Vector Shape - Rect",
                            },
                            {
                              ty: "fl",
                              c: { a: 0, k: [0.1764706, 0.8, 0.8039216, 1] },
                              o: { a: 0, k: 100 },
                              r: 1,
                              nm: "Fill 1",
                              mn: "ADBE Vector Graphic - Fill",
                            },
                            {
                              ty: "tr",
                              p: { a: 0, k: [0, 0], ix: 2 },
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              r: { a: 0, k: 0, ix: 6 },
                              o: { a: 0, k: 100, ix: 7 },
                              sk: { a: 0, k: 0, ix: 4 },
                              sa: { a: 0, k: 0, ix: 5 },
                              nm: "Transform",
                            },
                          ],
                          nm: "Rectangle 1",
                          np: 3,
                          cix: 2,
                          ix: 1,
                          mn: "ADBE Vector Group",
                        },
                        {
                          ty: "tr",
                          p: { a: 0, k: [-540, -375], ix: 2 },
                          a: { a: 0, k: [-540, -337.5], ix: 1 },
                          s: {
                            a: 1,
                            k: [
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: -170,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: -34,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: -28,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: -17,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: -6,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 0,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [1, 1] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p833_1_0p167_0p167",
                                  "0p833_1_0p167_0p167",
                                ],
                                t: 237,
                                s: [18.75, 30],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [0.667, 0.667] },
                                o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                                n: [
                                  "0p667_0p667_0p167_0p167",
                                  "0p667_0p667_0p167_0p167",
                                ],
                                t: 238,
                                s: [100, 100],
                                e: [100, 100],
                              },
                              {
                                i: { x: [0.742, 0.79], y: [0.175, 0.444] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p742_0p175_0p333_0",
                                  "0p79_0p444_0p333_0",
                                ],
                                t: 374,
                                s: [100, 100],
                                e: [97.04, 99.314],
                              },
                              {
                                i: { x: [0.829, 0.804], y: [0.649, 0.537] },
                                o: { x: [0.623, 0.651], y: [0.282, 0.06] },
                                n: [
                                  "0p829_0p649_0p623_0p282",
                                  "0p804_0p537_0p651_0p06",
                                ],
                                t: 380,
                                s: [97.04, 99.314],
                                e: [58.665, 63.182],
                              },
                              {
                                i: { x: [0.341, 0.381], y: [0.79, 0.903] },
                                o: { x: [0.194, 0.174], y: [0.406, 0.458] },
                                n: [
                                  "0p341_0p79_0p194_0p406",
                                  "0p381_0p903_0p174_0p458",
                                ],
                                t: 391,
                                s: [58.665, 63.182],
                                e: [20.952, 30.852],
                              },
                              {
                                i: { x: [0.667, 0.667], y: [1, 1] },
                                o: { x: [0.188, 0.193], y: [0.561, 0.624] },
                                n: [
                                  "0p667_1_0p188_0p561",
                                  "0p667_1_0p193_0p624",
                                ],
                                t: 402,
                                s: [20.952, 30.852],
                                e: [18.75, 30],
                              },
                              {
                                i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                                o: { x: [0.333, 0.333], y: [0, 0] },
                                n: [
                                  "0p833_0p833_0p333_0",
                                  "0p833_0p833_0p333_0",
                                ],
                                t: 408,
                                s: [18.75, 30],
                                e: [18.75, 30],
                              },
                              { t: 646 },
                            ],
                            ix: 3,
                          },
                          r: { a: 0, k: 0, ix: 6 },
                          o: { a: 0, k: 100, ix: 7 },
                          sk: { a: 0, k: 0, ix: 4 },
                          sa: { a: 0, k: 0, ix: 5 },
                          nm: "Transform",
                        },
                      ],
                      nm: "TL",
                      np: 1,
                      cix: 2,
                      ix: 1,
                      mn: "ADBE Vector Group",
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [540, -375], ix: 2 },
                      a: { a: 0, k: [540, -375], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "TR",
                  np: 1,
                  cix: 2,
                  ix: 1,
                  mn: "ADBE Vector Group",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-540, 300], ix: 2 },
                  a: { a: 0, k: [-540, 300], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: -170,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: -102,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: -96,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: -85,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: -74,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: -68,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [1, 1] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: ["0p833_1_0p167_0p167", "0p833_1_0p167_0p167"],
                        t: 237,
                        s: [533.5, 333.6],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0, 0] },
                        n: ["0p833_0p833_0p167_0", "0p833_0p833_0p167_0"],
                        t: 238,
                        s: [100, 100],
                        e: [100, 100],
                      },
                      {
                        i: { x: [0.812, 0.812], y: [0.439, 0.439] },
                        o: { x: [0.333, 0.333], y: [0, 0] },
                        n: ["0p812_0p439_0p333_0", "0p812_0p439_0p333_0"],
                        t: 306,
                        s: [100, 100],
                        e: [102.202, 102.202],
                      },
                      {
                        i: { x: [0.806, 0.806], y: [0.529, 0.541] },
                        o: { x: [0.659, 0.659], y: [0.034, 0.065] },
                        n: [
                          "0p806_0p529_0p659_0p034",
                          "0p806_0p541_0p659_0p065",
                        ],
                        t: 312,
                        s: [102.202, 102.202],
                        e: [332.952, 223.404],
                      },
                      {
                        i: { x: [0.377, 0.377], y: [0.945, 0.899] },
                        o: { x: [0.171, 0.171], y: [0.484, 0.457] },
                        n: [
                          "0p377_0p945_0p171_0p484",
                          "0p377_0p899_0p171_0p457",
                        ],
                        t: 323,
                        s: [332.952, 223.404],
                        e: [530.54, 330.64],
                      },
                      {
                        i: { x: [0.667, 0.667], y: [1, 1] },
                        o: { x: [0.258, 0.258], y: [0.825, 0.825] },
                        n: ["0p667_1_0p258_0p825", "0p667_1_0p258_0p825"],
                        t: 334,
                        s: [530.54, 330.64],
                        e: [533.5, 333.6],
                      },
                      {
                        i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                        o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                        n: [
                          "0p833_0p833_0p167_0p167",
                          "0p833_0p833_0p167_0p167",
                        ],
                        t: 340,
                        s: [533.5, 333.6],
                        e: [533.5, 333.6],
                      },
                      { t: 646 },
                    ],
                    ix: 3,
                  },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "BL",
              np: 1,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
            },
            {
              ty: "tr",
              p: { a: 0, k: [540, 300], ix: 2 },
              a: { a: 0, k: [540, 300], ix: 1 },
              s: { a: 0, k: [18.75, 30], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "BR",
          np: 1,
          cix: 2,
          ix: 1,
          mn: "ADBE Vector Group",
        },
      ],
      ip: 0,
      op: 409,
      st: -170,
      bm: 0,
      sr: 1,
    },
  ],
};

export default loader;
